/**
 * Constants for MetricData Dev Tool
 * @module MetricDataDevTool/constants
 */

/**
 * All available metric names in MetricData
 * @constant {string[]}
 */
export const METRIC_NAMES = [
  'bohOvertimeDollars',
  'bohOvertimeHours',
  'bohRegularDollars',
  'bohRegularHours',
  'checkCount',
  'fohOvertimeDollars',
  'fohOvertimeHours',
  'fohRegularDollars',
  'fohRegularHours',
  'giftCardSales',
  'grossSales',
  'netSales',
  'refunds',
  'serviceCharges'
];

/**
 * Default metric selections (all metrics)
 * @constant {string[]}
 */
export const DEFAULT_SELECTED_METRICS = [...METRIC_NAMES];

/**
 * Aggregation dimension options
 * @constant {Object}
 */
export const AGGREGATION_OPTIONS = {
  BY_DATE: 'byDate',
  BY_DAY_PART: 'byDayPart',
  BY_DINING_OPTION: 'byDiningOption'
};

/**
 * Query pagination configuration
 * @constant {Object}
 */
export const QUERY_CONFIG = {
  PAGE_SIZE: 1000, // Records per batch
  MAX_RETRIES: 3,
  TIMEOUT_MS: 30000 // 30 seconds
};

/**
 * CSV export configuration
 * @constant {Object}
 */
export const CSV_CONFIG = {
  ENCODING: 'utf-8',
  BOM: '\uFEFF', // UTF-8 BOM for Excel compatibility
  FILENAME_PREFIX: 'metricdata',
  DATE_FORMAT: 'yyyy-MM-dd'
};

/**
 * Table configuration
 * @constant {Object}
 */
export const TABLE_CONFIG = {
  ROWS_PER_PAGE_OPTIONS: [10, 25, 50, 100],
  DEFAULT_ROWS_PER_PAGE: 25,
  VIRTUALIZATION_THRESHOLD: 1000 // Enable virtualization for datasets larger than this
};

/**
 * Authorized user names for access control
 * @constant {string[]}
 */
export const AUTHORIZED_USERS = ['devuser', 'radixadmin'];

/**
 * Authorized display names for access control
 * @constant {string[]}
 */
export const AUTHORIZED_DISPLAY_NAMES = ['Dev User', 'Radix Admin'];

/**
 * Labor metrics - expect 2 records per store per day
 * @constant {string[]}
 */
export const LABOR_METRICS = [
  'bohOvertimeDollars',
  'bohOvertimeHours',
  'bohRegularDollars',
  'bohRegularHours',
  'fohOvertimeDollars',
  'fohOvertimeHours',
  'fohRegularDollars',
  'fohRegularHours'
];

/**
 * Sales metrics - expect 6 records per store per day
 * @constant {string[]}
 */
export const SALES_METRICS = [
  'checkCount',
  'giftCardSales',
  'grossSales',
  'netSales',
  'refunds',
  'serviceCharges'
];

/**
 * Expected record counts per metric type
 * @constant {Object}
 */
export const EXPECTED_RECORD_COUNTS = {
  LABOR: 2,  // 2 records per labor metric per store per day
  SALES: 6   // 6 records per sales metric per store per day
};

/**
 * UUID format regex pattern for legacy metricId detection
 * @constant {RegExp}
 */
export const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
